import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {QUERY_KEY_VIDEO_STREAMS} from '@containers/video/videoStreams/queryHooks/constants/queryKey'
import {getGetVideoStreamsListApi} from '@containers/video/videoStreams/api/api'


export const useGetVideoStreamsListQuery = (
	accountId: number
) => {
	
	const {onShowError} = useShowError()
	
	return useQuery({
		queryFn: () => getGetVideoStreamsListApi(accountId, onShowError),
		queryKey: [QUERY_KEY_VIDEO_STREAMS, accountId?.toString()],
		staleTime: 1000 * 60 * 30,
		enabled: !!accountId,
		placeholderData: keepPreviousData,
	})
}

